export enum OriginalsPublicActionTypes {
  FETCH_PUBLIC_ORIGINALS_REQUEST = 'originals-public/PUBLIC_ORIGINALS_REQUEST',
  FETCH_PUBLIC_ORIGINALS_SUCCESS = 'originals-public/FETCH_PUBLIC_ORIGINALS_SUCCESS',
  FETCH_PUBLIC_ORIGINALS_ERROR = 'originals-public/FETCH_PUBLIC_ORIGINALS_ERROR',
}
